import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Serivce
import ItemService from "../../../services/supplier_appCommonService";

//Components
import Layout from "../../../Layout/Layout";
import CreateDocTypeModal from "../../../Components/Modal/supplier_app/CreateDocTypeModal";
import Constants from "../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import {
  addRfqCreation,
  addRfxNr,
} from "../../../redux/feature/supplier_app/sourcingSlice";
import ShowStatus from "../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import ReverseTimer from "../../../Components/TableReverseTimer/ReverseTimer";
import { SearchField } from "../../../Components/formElements/SearchField";
import { currencyFormat, formatDateTime } from "../../../common/Validations";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";
import { MessageCircle } from "lucide-react";
import ChatBox from "../../../Components/ChatBox/ChatBox";
import StickyColumn from "../../../Components/Sticky/StickyColumn";
import { ChartBarIcon, FunnelIcon } from "@heroicons/react/24/solid";
import CommonFillter from "../../../Components/Filter/Supplier/SupplierCommonFillter";
import StatisticsContainer from "../../../Components/Cards/StatisticsCardContainer";
import MultiColumnFilter from "../../../Components/Filter/MultiColumnFilter";
import {
  getTndRFQList,
  tndRFQnNr,
} from "../../../redux/feature/supplier_app/purchasingSlice";
import TableActions from "../../smart_construction_app/Customer_V4/Common/TableActions/TableActions";
const TenderRfqList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Tender");
  localStorage.setItem("submenu", "Tender Request for Quotation");
  let rfqData = useSelector((state) => state?.purchasing?.tndRFQ); // User Details from Store

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");
  const [data, setData] = useState([]);
  const [showStats, setShowStats] = useState(false);
  const [filterShow, setFilterShow] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (!showStats) {
      setFilteredData(rfqData?.data);
    }
  }, [showStats, rfqData]);

  const handleChartClick = () => {
    setShowStats((prev) => !prev);
  };
  useEffect(() => {
    setData(rfqData?.data || []);
  }, [rfqData]);

  useEffect(() => {
    loadInitialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rfqData]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [modalData, setModalData] = useState({});
  const [getPurchaseDocType, setPurchaseDocType] = useState("");

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  /* Modal Function */
  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const [chatId, setChatId] = useState(null);
  const toggleChat = (groupId) => {
    // Toggle the same PR closes the chat
    if (chatId === groupId) {
      setChatId(null);
    } else {
      setChatId(groupId);
    }
  };
  const columns = [
    {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span className="iconTable">
            <button
              onClick={() => toggleChat(row?.userId)}
              title={row?.userId ? "Chat With the User" : "No User Found"}
              // className={`text-sm ${chatId === row.userId ? "text-green-600" : "text-blue-600"} hover:text-blue-800`}
            >
              <MessageCircle className="w-5 h-5" />
            </button>
          </span>
          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Buyer RFQ Details",
      selector: (row) => row.rfxNr,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageBuyer(row.rfxNr)}
        >
          {row.rfxNr}
        </button>
      ),
    },
    {
      name: "Gem Ref",
      selector: (row) => row.gemReferenceNr,
      sortable: true,
      width: "180px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemLevelShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Version",
      selector: (row) => row.rfxVersion,
      sortable: true,
      width: "100px",
    },
    {
      name: "Title",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold"> {row.rfxTitle} </span>
        </>
      ),
      selector: (row) => row.rfxTitle,
      sortable: true,
      width: "250px",
    },

    // Conditionally include the 'workflowActionLogs' column
    ...(data?.some((row) => row?.workflowActionLogs !== undefined)
      ? [
          {
            name: "Workflow log",
            cell: (row) => (
              <div
                style={{ width: "100%" }}
                className="d-flex justify-content-center iconTable"
              >
                <img
                  src="assets/img/newIcons/workflow.png"
                  alt="attachments"
                  style={{ width: "35px" }}
                  className="mt-1"
                  onClick={() => showStatusInfo(row.workflowActionLogs)}
                />
              </div>
            ),
            sortable: true,
            width: "132px",
          },
        ]
      : []),
    {
      name: "Status",
      selector: (row) => row.rfxHeaderStatus,
      id: "rfxHeaderStatus",
      dropDown: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.rfxHeaderStatus} />
        </>
      ),
      width: "200px",
    },
    {
      name: "RFX Value",
      selector: (row) => row.rfxValue,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">
            {" "}
            {currencyFormat(Number(row.rfxValue).toFixed(2))}{" "}
          </p>
          <p className="m-0 p-0">{row.rfxCurrency} </p>
        </div>
      ),
    },

    {
      name: "Open Date ",
      selector: (row) => formatDateTime(row.openingDateTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "Close Date",
      selector: (row) => formatDateTime(row.closingDateTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "Countdown Timer",
      cell: (row) => (
        <>
          {row.rfxHeaderStatus === "Published" ||
          row.rfxHeaderStatus === "QTN Received" ? (
            <ReverseTimer
              closingDateTime={row.closingDateTime}
              openingDateTime={row.openingDateTime}
            />
          ) : (
            <ReverseTimer closingDateTime={0} openingDateTime={0} />
          )}
        </>
      ),
      sortable: true,
      width: "270px",
    },
    {
      name: "Supplier List",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => supplierListShowModal(row.supplierList)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.supplierList?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Procurment Category",
      selector: (row) => row.rfxCategoryDesc,
      id: "rfxCategoryDesc",
      dropDown: true,
      sortable: true,
      width: "200px",
    },
    // {
    //   name: "Technical User",
    //   cell: (row) => (
    //     <>
    //       <span className="m-0 p-0 pt-1 fw-bold">
    //         {" "}
    //         {row.rfxTechFocalPersonId}{" "}
    //       </span>
    //     </>
    //   ),
    //   selector: (row) => row.rfxTechFocalPersonId,
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Extension Count",
      selector: (row) => row.extensionCount,
      sortable: true,
      width: "160px",
    },
    {
      name: "Bid Type",
      selector: (row) => row.rfxbidTypeCode,
      id: "rfxbidTypeCode",
      dropDown: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.rfxbidTypeCode} />
        </>
      ),
      sortable: true,
      width: "140px",
    },
    // {
    //   name: "Technical",
    //   cell: (row) => (
    //     <>
    //       {row.rfxHeaderStatus === "Tech Approved" ||
    //       row.rfxHeaderStatus === "Commercial Open" ||
    //       row.rfxHeaderStatus === "Commercial Approved" ||
    //       row.rfxHeaderStatus === "Commercial Pending with L1" ||
    //       row.rfxHeaderStatus === "Commercial Pending with L2" ? (
    //         <button
    //           className="btnApprove"
    //           onClick={() => detailedTechnicalEvaluationPage(row.rfxNr)}
    //         >
    //           TE Details
    //         </button>
    //       ) : (
    //         <button className="btnTable" disabled={true}>
    //           TE Details
    //         </button>
    //       )}
    //     </>
    //   ),
    //   width: "150px",
    // },
    // Conditionally include the 'workflowTECHActionLogs' column
    ...(data?.some((row) => row?.workflowTECHActionLogs !== undefined)
      ? [
          {
            name: "Flow",
            cell: (row) => (
              <div
                style={{ width: "100%" }}
                className="d-flex justify-content-center iconTable"
                onClick={() => showStatusInfo(row.workflowTECHActionLogs)}
              >
                <i className="bi bi-info-square"></i>
                {/* <img
                  src="assets/img/newIcons/workflow.png"
                  alt="attachments"
                  style={{ width: "35px" }}
                  className="mt-1"
                  onClick={() => showStatusInfo(row.workflowTECHActionLogs)}
                /> */}
              </div>
            ),
            sortable: true,
            width: "80px",
          },
        ]
      : []),
    {
      name: "Commercial",
      cell: (row) => (
        <>
          {row.rfxHeaderStatus === "Commercial Approved" ||
          row.rfxHeaderStatus === "Commercial Pending with L1" ||
          row.rfxHeaderStatus === "Commercial Pending with L2" ? (
            <>
              <button
                className="btnApprove"
                onClick={() => detailedCommercialEvaluation(row.rfxNr)}
              >
                CE Details
              </button>
            </>
          ) : row.rfxHeaderStatus === "Commercial Open" ? (
            <button
              className="btnTable"
              onClick={() => createCommercialEvaluation(row.rfxNr)}
            >
              CE Prepare
            </button>
          ) : (
            <button className="btnTable" disabled={true}>
              CE Prepare
            </button>
          )}
        </>
      ),
      width: "140px",
    },
    // Conditionally include the 'workflowCOMMActionLogs' column
    ...(data?.some((row) => row?.workflowCOMMActionLogs !== undefined)
      ? [
          {
            name: "Flow",
            cell: (row) => (
              <div
                style={{ width: "100%" }}
                className="d-flex justify-content-center iconTable"
                onClick={() => showStatusInfo(row.workflowCOMMActionLogs)}
              >
                <i className="bi bi-info-square"></i>
                {/* <img
                  src="assets/img/newIcons/workflow.png"
                  alt="attachments"
                  style={{ width: "35px" }}
                  className="mt-1"
                  onClick={() => showStatusInfo(row.workflowCOMMActionLogs)}
                /> */}
              </div>
            ),
            sortable: true,
            width: "80px",
          },
        ]
      : []),

    {
      name: "Order",
      cell: (row) => (
        <>
          {/* <button className="btnTable" onClick={() => createPO()}>
            Create PO
          </button> */}
          {row.rfxHeaderStatus === "Commercial Approved" ||
          row.rfxHeaderStatus === "Commercial Pending with L1" ||
          row.rfxHeaderStatus === "Commercial Pending with L2" ? (
            <>
              <button className="btnTable" onClick={() => createPO(row.rfxNr)}>
                Create
              </button>
            </>
          ) : row.rfxHeaderStatus === "Commercial Open" ? (
            <button className="btnTable" onClick={() => createPO(row.rfxNr)}>
              Prepare
            </button>
          ) : (
            <button className="btnTable" disabled={true}>
              Prepare
            </button>
          )}
        </>
      ),
      width: "140px",
    },
    {
      name: "Company",
      id: "companyAddressDesc",
      dropDown: true,
      cell: (row) => (
        <>
          <span> {row.companyAddressDesc} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Buyer",
      selector: (row) => row.buyerConact,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.buyerResponsible} </p>
          <p className="m-0 p-0 pt-1">{row.buyerConact} </p>
          <p className="m-0 p-0">{row.buyerEmail} </p>
        </div>
      ),
    },
    {
      name: "Envelope Type",
      selector: (row) => row.rfxTypeDesc,
      sortable: true,
      width: "250px",
    },
    {
      name: "Product",
      selector: (row) => row.productType,
      id: "productType",
      dropDown: true,
      sortable: true,
      width: "150px",
    },
     {
      name: "Action",
      cell: (row) => (
        <TableActions
          actions={[
          {
              label: "Details",
              icon: "bi bi-info-circle",
              iconClass: "text-success",
              bg: "#e6f7ee",
              // onClick: () => showAddProduct("EDIT", row.documentNumber),
            },
            {
              label: "Edit",
              icon: "bi bi-pencil-square",
              iconClass: "text-success",
              bg: "#e6f7ee",
              // onClick: () => showAddProduct("EDIT", row.documentNumber),
            },
            {
              label: "Delete",
              icon: "bi bi-trash",
              iconClass: "text-danger",
              bg: "#fdeaea",
              // onClick: () => deleteMaterial(row),
            },
            {
              label: "More",
              icon: "bi bi-three-dots",
              bg: "#f1f3f5",
              onClick: () => console.log("More", row),
            },
          ]}
        />
      ),
      width: "180px",
    },
  ];

  const supplierListColInfo = [
    {
      name: "Supplier Name",
      selector: (row) => row.AssociateNumber,
      sortable: true,
      width: "180px",
    },
    {
      name: "Supplier Name",
      selector: (row) => row.organisationName,
      sortable: true,
      width: "200px",
    },
    {
      name: "Supplier Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.status} />
        </>
      ),
      width: "180px",
    },
    {
      name: "Mail",
      selector: (row) => row.email || "--",
      sortable: true,
      width: "250px",
    },
    {
      name: "Contact",
      selector: (row) => row.contactNumber,
      sortable: true,
      width: "200px",
    },
    {
      name: "Country",
      selector: (row) => row.country,
      sortable: true,
      width: "140px",
    },
    {
      name: "RFX Status",
      selector: (row) => row.rfxSupplierStatus,
      sortable: true,
      width: "160px",
    },
    {
      name: "Supplier Status",
      selector: (row) => row.qtnSupplierStatus,
      sortable: true,
      width: "150px",
    },
    {
      name: "Quotation Number",
      selector: (row) => row.quotationNr,
      sortable: true,
      width: "180px",
    },
    {
      name: "Quotation Version",
      selector: (row) => row.qtnVersion,
      sortable: true,
      width: "180px",
    },
  ];

  const handleFilterData = async (filters) => {
    const obj = {
      queryName: "GET_RFX_List",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    dispatch(getTndRFQList(obj));
  };

  const columnsForFilter = columns
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));
  const LineItemsColInfo = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row.materialCode} </p>
            <p className="m-0 p-0">{row.materialDescription} </p>
          </div>
        </>
      ),
      width: "180px",
      sortable: true,
    },
    {
      name: "Material Desc",
      selector: (row) => row.materialGroupDescription,
      sortable: true,
      width: "250px",
    },
    {
      name: "Quantity Unit",
      selector: (row) => row.unit || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Quantity",
      selector: (row) => row.purchaseQuantity,
      sortable: true,
      width: "150px",
    },
    {
      name: "Item Value ", // calculation
      selector: (row) => row.qtnitemValue || "--",
      width: "120px",
    },
  ];

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on Line Item Level Data
  const lineItemLevelShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(LineItemsColInfo);
    setModalTitle("Line Item Level Details");
    setItemLevelModalShow(true);
  };

  // OnClick on Supplier List Data
  const supplierListShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(supplierListColInfo);
    setModalTitle("Supplier List Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  /* Modal Function */
  let obj = {
    modalTitle: "Create Manual RFQ",
    navigate: Constants.SOURCING_CREATE_MANUAL_RFQ,
  };
  const createRFQ = () => {
    setModalData(obj);
    setModalShow(true);
    dispatch(addRfqCreation("Manual"));
  };

  const hideModal = () => {
    setModalShow(false);
  };

  // eslint-disable-next-line no-unused-vars
  const detailedPageVendor = (rfxNr) => {
    dispatch(addRfxNr(rfxNr));
    navigate(Constants.SOURCING_VENDOR_RFQ_DETAILS);
  };
  const detailedPageBuyer = (rfxNr) => {
    dispatch(tndRFQnNr(rfxNr));
    navigate(Constants.TND_RFQ_DETAIL);
  };
  // eslint-disable-next-line
  const detailedTechnicalEvaluationPage = (rfxNr) => {
    dispatch(addRfxNr(rfxNr));
    navigate(Constants.SOURCING_TECHNICAL_EVALUATION);
  };

  const loadInitialData = () => {
    setData(rfqData?.data);
  };

  //Create CE
  const createCommercialEvaluation = (rfxNr) => {
    dispatch(addRfxNr(rfxNr));
    navigate(Constants.TND_COMMERCIAL_EVAL);
  };
  //Create CE
  const detailedCommercialEvaluation = (rfxNr) => {
    dispatch(addRfxNr(rfxNr));
    navigate(Constants.TND_COMMERCIAL_EVAL_DETAILS);
  };
  //Create PO
  const createPO = (rfxNr) => {
    dispatch(addRfxNr(rfxNr));
    navigate(Constants.TND_PURCHASE_ORDER_CREATION);
    // navigate(Constants.SOURCING_PURCHASE_ORDER_CREATION);
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "GET_RFX_List",
      page: page,
      per_page: getNewPerPage,
    };

    dispatch(getTndRFQList(obj));
    // dispatch(getTndRFQList({}));
    setData(rfqData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "GET_RFX_List",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getTndRFQList(obj));
    setData(rfqData?.data);
  };

  useEffect(() => {
    loadInitialData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rfqData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "GET_RFX_List",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getTndRFQList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getMasterData = async () => {
    let obj = {
      codeType: "RFQCategory",
    };
    await ItemService.getMasterData(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setPurchaseDocType(item?.data);
      } else {
        setPurchaseDocType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  //on page load
  useEffect(() => {
    getMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getTndRFQList(obj));
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Tender RFQ List</h2>
                <p className="subText">Lists of Tender RFQ and details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <Col xs={12} md={12} lg={12}>
              <Row className="align-items-end justify-content-end">
                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setShowStats(!showStats)}
                    className="icon-btn"
                  >
                    <ChartBarIcon className="icon-svg" />
                  </button>
                </Col>

                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setFilterShow(!filterShow)}
                    className="icon-btn"
                  >
                    <FunnelIcon className="icon-svg" />
                  </button>
                </Col>
              </Row>
            </Col>

            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                fetchFunction={ItemService.generateQueryV1}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
                queryName="GET_RFX_List"
              />
            )}
            <hr />

            {showStats && (
              <div className="stats-box p-3 mb-3 position-relative">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="m-0">Statistics</h5>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "red",
                    }}
                    onClick={() => setShowStats(false)}
                  >
                    ×
                  </span>
                </div>

                <StatisticsContainer
                  api={ItemService.generateQueryV1}
                  keyName="rfxHeaderStatus"
                  paginatedList={rfqData.data || []}
                  showStats={showStats}
                  onFilter={(data) => setFilteredData(data)}
                  queryName="GET_RFX_List"
                />
              </div>
            )}

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RQ</span>
                    </Col>
                    <Col xs={12} md={5} lg={5}>
                      <span className="headerTitle">RFQ List</span>
                      <span className="subHeaderTitle">
                        View of Request For Quotation and Status{" "}
                      </span>
                    </Col>
                    <Col xs={2} md={2} lg={2} className="">
                      <button className="btnTable" onClick={() => createRFQ()}>
                        <i className="bi bi-plus-lg"></i> Create Manual
                      </button>
                    </Col>
                    <Col xs={2} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => {
                          alert("asd");
                        }}
                      >
                        <i className="bi bi-x-circle"></i> Cancel
                      </button>
                    </Col>
                    <Col xs="auto" md="auto" lg="auto">
                      <CommonFillter onChartClick={handleChartClick} />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn
                        columnIndexes={[2, 3]}
                        leftOffsets={[0, 120]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          // data={data}
                          data={filteredData}
                          progressPending={rfqData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={rfqData?.pagination?.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CreateDocTypeModal
        show={modalShow}
        onHide={() => hideModal()}
        modaldata={modalData}
        dropdowndata={getPurchaseDocType}
        navigate={Constants.SOURCING_CREATE_RFQ}
      />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />

      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )}
    </main>
  );
};

export default TenderRfqList;
